import { createReducer } from "@reduxjs/toolkit";
import {
  CORE_LAYOUT_ERROR,
  CORE_LAYOUT_LOADING,
  CREATE_CORE_LAYOUT,
  EDIT_CORE_LAYOUT,
  LIST_CORE_LAYOUT,
  DELETE_CORE_LAYOUT,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const coreLayoutReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(CORE_LAYOUT_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(CORE_LAYOUT_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(LIST_CORE_LAYOUT, (state, { payload }) => {
      state.data = payload.data;
      state.loading = false;
    })
    .addCase(CREATE_CORE_LAYOUT, (state, { payload }) => {
      Array.isArray(state.data)
        ? state.data.push(payload)
        : (state.data = [payload]);
      state.loading = false;
    })
    .addCase(EDIT_CORE_LAYOUT, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    })
    .addCase(DELETE_CORE_LAYOUT, (state, { payload }) => {
      state.data = state.data.filter((e) => e?.id !== payload?.id);
      state.loading = false;
    });
});

export default coreLayoutReducer;
